import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import './flex.js';
import './styles.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
class NimbusForgetPasswordForm extends PolymerElement {
  static get template() {
    return html`
    <style include="nimbus-flex"></style>
    <style include="nimbus-styles">
      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Italic.eot');
        src: url('fonts/NotoSans-Italic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Italic.woff') format('woff'),
          url('fonts/NotoSans-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Bold.eot');
        src: url('fonts/NotoSans-Bold.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Bold.woff') format('woff'),
          url('fonts/NotoSans-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-BoldItalic.eot');
        src: url('fonts/NotoSans-BoldItalic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-BoldItalic.woff') format('woff'),
          url('fonts/NotoSans-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans.eot');
        src: url('fonts/NotoSans.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans.woff') format('woff'),
          url('fonts/NotoSans.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
      .ndsgn-auth-form-top-icon-img {
        display:block;
        background:url(images/nimbus-note.svg) no-repeat center;
        width:100%;
        height:60px;
      }

      :host(.nns-theme-night) .ndsgn-auth-form-top-icon-img {
        background: url(images/nimbus-note-dark.svg) no-repeat center;
      }
    </style>

    <iron-ajax id="forget_password_ajax" url="{{authUrl}}/api/forget-password" method="POST" handle-as="json" on-response="handleResponse" on-error="handleError" content-type="application/json"></iron-ajax>

      <div class="ndsgn-auth-form-top" flex="none">
        <div class="ndsgn-auth-form-top-icon">
          <i class="ndsgn-auth-form-top-icon-img"></i>
        </div>
        <template is="dom-if" if="{{formError}}">
          <div class="ndsgn-auth-form-top-text" flex="none">[[formError]]</div>
        </template>
      </div>

      <div class="ndsgn-auth-form-main-fields" flex="none">
        <div class\$="[[loginClass]]">
          <input autocapitalize="none" autocorrect="off" id="login" type="text" placeholder="Email or Username" required="" on-keypress="keypress">
          <template is="dom-if" if="{{loginError}}">
            <div class="ndsgn-input-error-text">[[loginError]]</div>
          </template>
        </div>

        <div class="ndsgn-auth-form-submit">
          <button class="ndsgn-button ndsgn-button-full-width" type="submit" on-click="sendLogin">
            <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
              Restore password
            </span>
          </button>
        </div>
      </div>
`;
  }

  static get is() { return "nimbus-forget-password-form"; }
  static get properties() {
    return {
      'authUrl': String,
      'formError': String,
      'loginError': String,
      'loginClass': String
    }
  }

  constructor() {
    super();
  }

  handleResponse() {
    let response = this.$.forget_password_ajax.lastResponse;
    if (!response || response.error) {
      switch (response.error) {
        case 'USER_NOT_FOUND':
          this.set('loginError', 'User not found');
          this.set('loginClass', 'ndsgn-input ndsgn-input-invalid');
          break;
        case 'TOO_MANY_REQUESTS':
          this.set('formError', 'Too many attempts. Please wait 15 minutes');
          break;
        case 'WRONG_REQUEST':
          this.set('formError', 'Something wrong');
          break;
      }
    } else {
      const event = new CustomEvent('restore-password', {bubbles: true, composed: true});
      this.dispatchEvent(event);
      this.set('formError', 'Please check email');
    }
  }

  handleError() {

  }

  ready() {
    super.ready();
    this.clearErrors();
  }

  keypress(e) {
    var key = e.which || e.keyCode;
    if (key === 13) {
      this.sendLogin();
    }
  }

  clearErrors() {
    this.set('loginError', '');
    this.set('loginClass', 'ndsgn-input');
    this.set('passwordError', '');
    this.set('passwordClass', 'ndsgn-input');
    this.set('formError', '')
  }

  sendLogin() {
    this.clearErrors();
    let login = this.$.login.value;
    let isError = false;
    if (!login) {
      this.set('loginError', "Field can't be empty!");
      this.set('loginClass', 'ndsgn-input ndsgn-input-invalid');
      isError = true;
    }
    if (isError) {
      return;
    }
    this.$.forget_password_ajax.body = {
      login
    }
    this.$.forget_password_ajax.generateRequest();
  }
}
customElements.define(NimbusForgetPasswordForm.is, NimbusForgetPasswordForm);
